export enum AuthenticationGetters {
  hasErrorMessages = 'hasErrorMessages',
  errorMessages = 'errorMessages',
  jwtData = 'jwtData',
  jwtEmail = 'jwtEmail',
  jwtRoles = 'jwtRoles',
  jwtExpires = 'jwtExpires',
  jwtVeterinarianOfficeId = 'jwtVeterinarianOfficeId',
  hasAcceptedTerms = 'hasAcceptedTerms',
  hasTagGottaMatch = 'hasTagGottaMatch',
  hasOwnerAuthenticated = 'hasOwnerAuthenticated'
}

export enum VeterinarianGetters {
  hasErrorMessages = 'hasErrorMessages',
  errorMessages = 'errorMessages'
}

export enum AdminUserGetters {
  hasErrorMessages = 'hasErrorMessages',
  errorMessages = 'errorMessages'
}

export enum CustomerGetters {
  hasErrorMessages = 'hasErrorMessages',
  errorMessages = 'errorMessages'
}

export enum RegisteredTagGetters {
  hasErrorMessages = 'hasErrorMessages',
  errorMessages = 'errorMessages'
}

export enum VeterinarianUserGetters {
  hasErrorMessages = 'hasErrorMessages',
  errorMessages = 'errorMessages'
}
